module.exports = __webpack_public_path__ + "static/media/N05.55b57b4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N05.svg
// module id = 188
// module chunks = 0